import WhatsappPopup from './WhatsappPopup';

export type { TypeWhatsappPopupProps } from './types';
export default WhatsappPopup;
